<template>
   <div class="movie-box page-padding-bottom2">
       <!-- 返回 -->
        <div class="movie-box">
            <MovieGoBack :style="backstyle" :arrowStyle="arrowStyle" :text="'退票'" :titleStyle="titleStyle"></MovieGoBack>
        </div>
        <!-- 详情 -->
        <div class="ticket-order-info-wrapper padding20 page-background-color-white">
            <div class="page-div-bottom-line">
                <p class="page-margin-bottom1 acea-row row-between-wrapper">
                    <span v-if="orderInfo.orderNumber">订单号：{{orderInfo.orderNumber}}</span>
                    <span v-if="orderInfo.status" class="font-color-red">{{orderInfo.status}}</span>
                </p>
                <p class="page-margin-bottom1" v-if="orderInfo.orderTime">
                    下单时间：{{orderInfo.orderTime}}
                </p>
            </div>
            <div class="movie-box page-margin-top2">
                <p class="page-margin-bottom1" v-if="orderInfo.ticketName">票品名：{{`＜${orderInfo.ticketName}＞`}}</p>
                <p class="page-margin-bottom1" v-if="orderInfo.travelDate">出游日期：{{orderInfo.travelDate}}</p>
                <p class="page-margin-bottom1" v-if="orderInfo.number">总数量：{{orderInfo.number}}张</p>
                <p class="font-color-red page-margin-bottom1" v-if="orderInfo.price">总价：{{orderInfo.price}}</p>
                <p class="page-margin-bottom1" v-if="orderInfo.payType">支付方式：{{orderInfo.payType}}</p>
            </div>
        </div>
        <!-- 退订信息 -->
        <div class="ticket-order-info-wrapper page-background-color-white">
            <div class="title-bg padding20 title-font">
                退票信息
            </div>
            <ul class="movie-box padding20 page-margin-top2">
                <li class="page-margin-bottom1 acea-row row-between" @click="isShowType(true)">
                    <span>退票类型:</span>
                    <p class="reason-choice">{{typeOption.type_text}}</p>
                    <span>></span>
                </li>
                <TicketOrderSelectWindow :arr="type_list" :_isShow="openTypeSelect" @checkedOption="checkedTypeOption" @isShow="isShowType"></TicketOrderSelectWindow>
            <!-- 部分退 -->
                <li class="page-margin-bottom1 acea-row" v-if="typeOption.value == 2">
                    退票数量：<p><span class="page-text-center count" @click="count_reduce">-</span> {{refund_num}} <span class="page-text-center count" @click="count_add">+</span></p>
                </li>
                <li class="page-margin-bottom1 acea-row" v-if="typeOption.value == 2 && tourist_list.length !== 0">
                    选择退票游客：
                    <div class="tourist-wrapper">
                        <p class="page-margin-bottom1" v-for="(item, ind) in tourist_list" :key="ind" @click="chooseTourists(item)"><span class="option"><span v-if="item.isshow">√</span></span>{{item.name}}</p>
                    </div>
                    <em class="tips">（*注：再次点击被选中游客可取消）</em>
                </li>
            <!--  -->
                <li class="page-margin-bottom1 acea-row row-between" @click="isShow(true)">
                    <span>退票原因:</span>
                    <p class="reason-choice">{{reason_option.reason_text}}</p>
                    <span>></span>
                </li>
                <TicketOrderSelectWindow :arr="reason_list" :_isShow="openSelect" @checkedOption="checkedOption" @isShow="isShow"></TicketOrderSelectWindow>
                
                <li class="page-margin-bottom1 acea-row row-between">
                    <span>备注：</span>
                    <textarea
                        placeholder="填写备注信息，100字以内"
                        class="reason-text"
                        v-model="refund_reason"
                    ></textarea>
                </li>
                <li class="page-margin-bottom1">
                    预计退款金额：{{amountOfMoney}}
                </li>
            </ul>
        </div>

        <div class="ticket-order-info-wrapper page-background-color-white bottom" v-if="noticeList.content.length != 0">
            <div class="title-bg padding20 title-font">
                {{noticeList.title}}
            </div>
            <ul class="movie-box pad20">
                <li class="page-div-bottom-line padtb20">
                    <p v-for="(val, ind) in noticeList.content" :key="ind">{{val.content}}</p>
                </li>
            </ul>
        </div>

        <div @click="submit_order">
            <MovieBottomButton :text="btn_title" :cancel="cancel"></MovieBottomButton>
        </div>
   </div>
</template>

<script>
import MovieGoBack from "@components/MovieGoBack.vue";
import MovieBottomButton from "@components/MovieBottomButton.vue";
import TicketOrderSelectWindow from "@components/TicketOrderSelectWindow.vue";
import { getTicketRefundOrderDetail, applyRefund } from "@api/ticket.js";
import { roundFun } from "@utils/movie.js";

export default {
    name: "TicketRefund",
    components: {
        MovieGoBack,
        MovieBottomButton,
        TicketOrderSelectWindow
    },
    data: function () {
        return {
            backstyle: {
                background: '#fff'
            },
            arrowStyle: {
                color: '#666'
            },
            titleStyle: {
                color: '#666',
                'text-align': 'center',
                "font-size": '.29rem'
            },
            reason_option: {
                reason_text: "请选择",//退票原因
                reason_value: "",//退票原因value值
            },
            reason_list: [
                { text: "自定义", value: 0 },
                { text: "确认超时", value: 1 },
                { text: "行程不确定", value: 2 },
                { text: "价格原因", value: 3 },
                { text: "信息错误重新预定", value: 4 },
                { text: "重复预定", value: 5 },
                { text: "预定流程不方便", value: 6 },
                { text: "变更流程不方便", value: 7 },
                { text: "支付遇到问题", value: 8 }
            ],
            openSelect: false, //退票原因
            openTypeSelect: false, //退票类型
            typeOption: { //退票类型值
                type_text: "请选择",
                value: null
            },
            type_list: [
                { text: "全退", value: 1 }
            ],
            noticeList: {
                    title: "退改说明",
                    content: [
                        // {
                        //   content: "使用日期前3天01:00（含）之前申请取消，收取1元/份损失费；"  
                        // }
                    ]
            },
            cancel: false, //点击无效
            btn_title: "退票" ,
            id: this.$route.params.id,
            refund_num: 1, //当前退票数量
            numberOfTrips: {
                min: 1, // 最少出行人数
                max: null //出行总人数
            },
            amountOfMoney: 0, //退票金额
            xieChengAll: "", //携程预计退款金额（总）
            tourist_list: [   //总游客信息
                // { name:"吴奇隆", id:1, isshow: false },
                // { name:"乔振宇", id:2, isshow: false },
                // { name:"严屹宽", id:3, isshow: false }
            ],
            refund_reason: "", //备注
            orderInfo: {
                orderNumber: "", //订单号
                status: "", //状态
                orderTime: "", //下单时间
                //
                ticketName: "", //票品名
                travelDate: "", //出游日期
                number: null,//总数量
                price: null, //总价格
                payType: "", //支付方式
            },
            damage_price: 0 //折损后应退的单价
        }
    },
    mounted: function () {
        this.getData();
    },
    methods: {
        chooseTourists: function (item) { //选择退票游客
            let num = 0;
            let change = true;
            this.tourist_list.forEach((tourist)=>{
                if (tourist.isshow && item.id != tourist.id) {
                    num+=1;
                }
                if (item.id == tourist.id && tourist.isshow ) {
                    tourist.isshow = !tourist.isshow;
                    change = false;
                }
            });
            if (num >= this.refund_num) {
                this.$dialog.toast({ mes: "只能选择"+this.refund_num+"位游客" });
            } else if ( num < this.refund_num && change) {
                item.isshow = !item.isshow;
            }
        },
        count_reduce: function () {//减
             if ( this.refund_num <= this.numberOfTrips.min ) {
                 this.refund_num = 1;
                 //退票金额
                 this.amountOfMoney = roundFun(this.damage_price * this.refund_num);
                 this.$dialog.toast({ mes: "最少退一位" });
             } else {
                 this.refund_num -= 1;
                 //退票金额
                 this.amountOfMoney = roundFun(this.damage_price * this.refund_num);
                 if (this.tourist_list.length !== 0) {
                    let num = 0;
                    let showList = [];
                    this.tourist_list.forEach((tourist, index)=>{
                        if (tourist.isshow) {
                            num+=1;
                            showList.push(index);
                        }
                    });
                    if (num - this.refund_num > 0) {
                        let new_list = showList.splice(0, num - this.refund_num);
                        new_list && new_list.forEach((itm)=>{
                            this.tourist_list[itm].isshow = false;
                        });
                    }
                 }
             }
        },
        count_add: function () { //加
            if (this.refund_num >= this.numberOfTrips.max ) {
                this.refund_num = this.numberOfTrips.max;
                this.$dialog.toast({ mes: "最多退"+this.numberOfTrips.max+"位" });
            } else {
                this.refund_num += 1;
            }
            //退票金额
            this.amountOfMoney = roundFun(this.damage_price * this.refund_num);
        },
        isShowType: function (val) {
            this.openTypeSelect = val;
        },
        checkedTypeOption: function (val) {
            this.typeOption = {
                type_text: val.text,
                value: val.value
            };
            if (val.value == 1) { //全退
                this.refund_num = this.orderInfo.number; //当前退票人数=最多人数 总出游人数/总票数；
                //退票金额
                //this.amountOfMoney = roundFun(this.damage_price * this.numberOfTrips.max);
                this.amountOfMoney = this.amountOfMoney;
            } else { //部分退
                this.refund_num = this.numberOfTrips.min;
                if (this.tourist_list.length !== 0 ) {
                    this.tourist_list.forEach((item)=>{
                        item.isshow = false;
                    });
                }
                //退票金额
                this.amountOfMoney = roundFun(this.damage_price * this.refund_num);
            }
        },
        isShow: function (val) {
            this.openSelect = val;
        },
        checkedOption: function (value) {
            this.reason_option = {
                reason_text :value.text,
                reason_value : value.value
            }
        },
        getData: function () {
            this.$dialog.loading.open("正在加载中");
            const id = this.id || this.$route.params.id;
            getTicketRefundOrderDetail(id).then((res)=>{
                this.$dialog.loading.close();
                   const datas = res && res.data;
                   let orderInfo = datas && datas.orderInfo;
                   this.orderInfo = {
                        orderNumber: orderInfo.order_id, //订单号
                        status: orderInfo._status._title, //状态
                        orderTime: orderInfo.create_time, //下单时间
                        //
                        ticketName: orderInfo.tickets_name, //票品名
                        travelDate: orderInfo._use_time, //出游日期
                        number: roundFun(orderInfo.total_num, 2),//总数量
                        price: roundFun(orderInfo.pay_price, 2), //总价格
                        payType: orderInfo._status._payType, //支付方式
                    };
                   
                    let refundticketInfo = datas && datas.refundticketInfo;
                    let refundOtherRequirement = refundticketInfo.CancelItems && refundticketInfo.CancelItems[0].RefundOtherRequirement;
                    // 1:可部分退  2:：不可部分退
                    let clientInfoList = refundticketInfo.CancelItems && refundticketInfo.CancelItems[0].clientInfoList || [];
                    // if ( refundOtherRequirement == 1) {
                    //     this.type_list.push({
                    //         text: "部分退", value: 2
                    //     });
                    //     let arr = [];
                    //     clientInfoList && clientInfoList.forEach((val, ind)=>{
                    //         arr.push({
                    //             name: val.ClientName || val.ClientEName,
                    //             id: val.ClientID,
                    //             isshow: false
                    //         });
                    //     });
                    //     this.tourist_list = arr;
                    //     this.numberOfTrips.max = arr.length || 1;
                    // }
                    //这个值表示 单个折损后的应退金额
                    //this.damage_price = 0; 

                    //涉及到部分退时需要再 重新计算
                    this.amountOfMoney = refundticketInfo._TotalAmount;//预计可退款金额 (总) refundticketInfo.TotalAmount
                    this.xieChengAll = refundticketInfo.TotalAmount; //携程预计可退款
            
                    const ticketOrderInfos = datas && datas.ticketOrderInfo && datas.ticketOrderInfo.OrderInfo && datas.ticketOrderInfo.OrderInfo.OrderItemInfos[0] && datas.ticketOrderInfo.OrderInfo.OrderItemInfos[0].ExtendProperty;
                    let ticketOrderInfo = ticketOrderInfos.ResourceExtendPropertyInfo.AddInfos;
                    let refund_noticeList = [];
                    
                    ticketOrderInfo && ticketOrderInfo.forEach((value)=>{
                        if (value.ResourceId == 114) {
                            value && value.ProductAddInfoDetails.forEach((item)=>{
                                refund_noticeList.push({
                                    content: item.DescDetail
                                });
                            })
                        }
                    });

                    this.noticeList.content = refund_noticeList;
        
            }).catch((err)=>{
             this.$dialog.loading.close();
                console.log(err);
            });
        },
        submit_order: function () { //退票
            if (this.cancel) return;

            //检查
            if (!this.typeOption.value) {
                this.$dialog.error("请选择退票类型");
                return;
            };
            if (!this.reason_option.reason_value) {
                this.$dialog.error("请选择退票原因");
                return;
            };

            this.$dialog.confirm({
                mes: "确认退票?",
                opts: () => {
                    // console.log(this.tourist_list, this.refund_num, this.amountOfMoney, this.typeOption, this.reason_option, this.refund_reason);
                    let data = {
                        id: parseFloat(this.id || this.$route.params.id), // 订单id
                        plan_refund_price: this.amountOfMoney, //预计退款金额 平台
                        plan_crtiprefund_price: this.xieChengAll, //携程预计退款金额
                        // num: this.refund_num, //退票数量
                        // refundtype: ,//退票类型
                        canceltype: parseFloat(this.reason_option.reason_value),//退票原因
                        reason: this.refund_reason//备注
                    };
                    this.$dialog.loading.open("退票中请稍后");
                    applyRefund(data).then((res)=>{
                        this.$dialog.loading.close();
                        if (res.status == 200) {
                            this.$dialog.success(res.msg);
                            this.$router.replace("/ticketOrders/2");//去订单列表页=>已完成状态时的订单列表
                        } else {
                            this.$dialog.error(res.msg);
                            this.$router.back();//返回上一页
                        };
                    }).catch((err)=>{
                        this.$dialog.loading.close();
                        // console.log(err);
                        this.$dialog.error(err.msg);
                        this.$router.back();//返回上一页
                    });
                }
            });
        }
    }
}
</script>

<style scoped>
.ticket-order-info-wrapper {
    width: 92%;
    margin: .2rem auto 0;
    border-radius: .1rem;
}
.title-bg {
    background-color: #e9332312;
}
.title-font {
    font-size: .32rem;
    color: #666;
}
.reason-text {
    width: 85%;
    height: 2rem;
    border: .02rem solid #ccc;
    border-radius: .1rem;
    box-sizing: border-box;
    padding: .1rem;
}
.reason-choice {
    width: 70%;
}
.count {
    display: inline-block;
    width: .3rem;
    height: .3rem;
    border: .02rem solid #fc4141;
    border-radius: 50%;
    line-height: .25rem;
    margin: 0 .16rem;
}
.option {
    display: inline-block;
    width: .3rem;
    color: lightcoral;
    margin: 0 .2rem;
}
.tourist-wrapper {
    width: 68%;
    overflow-x: hidden;
    max-height: 2.8rem;
    overflow-y: scroll;
}
.tips {
    color: #999;
    font-style: oblique;
}
.bottom {
    margin-bottom: 1.1rem;
}
</style>